import React, {Component} from 'react';
import {strings} from "../Configuration/Config";
import ChannleItem from './ChannelItem'
import {Form} from 'react-bootstrap'

class Step2 extends Component {
    constructor(props) {
        super(props);

        this.updateData = this.updateData.bind(this);
    }

    updateData() {
        if (!this.props.updateData) {
            alert("Funkce pro občerstvení data není definovaná!!!");
            return;
        }

        this.props.updateData();
    }

    render() {
        if (this.props.currentStep !== 2 && this.props.data.wizard) { // Prop: The current step
            return null
        }

        // The markup for the Step 1 UI
        return (
            <div className={"upper-border"}>
                <Form.Row>
                    <Form.Label column="lg" lg={2}>{strings.measure}</Form.Label>
                </Form.Row>
                <ChannleItem
                    channelKey="fei"
                    updateData={this.updateData}
                    data={this.props.data}
                />
                <ChannleItem
                    channelKey="dachang"
                    updateData={this.updateData}
                    data={this.props.data}
                />
                <ChannleItem
                    channelKey="xinbao"
                    updateData={this.updateData}
                    data={this.props.data}
                />
                <ChannleItem
                    channelKey="sanjiao"
                    updateData={this.updateData}
                    data={this.props.data}
                />
            </div>
        )
    }
}

export default Step2